export default function getEnumByValue<T extends { [key: string]: string }>(
  enumObj: T,
  value: string,
): T[keyof T] | undefined {
  return Object.values(enumObj).find((v): v is T[keyof T] => v === value);
}
